import {doc} from './docs.js';
doc(
    "messageSplitter",
    {
    },
    "Splits multi-part message, sending out from each outlet",
    (n) => n);
export const messageSplitter = (object) => {
    return ([...msgParts]) => {
        for (let i=0; i < msgParts.length; i++) {
            object.sendMessage(object.outputByNumber(i), msgParts[i]);
        }
    };
};

doc(
    "messageFilter",
    {
        condition: ""
    },
    "Lets messages pass through when condition is met.",
    undefined,
    {
        isHot: true,
        inlets: 2
    });

// todo: Actually implement
export const messageFilter = (object, condition) => {
    let stored = undefined;
    return (msg) => {
        if (condition()) {
            return msg;
        }
    };
};

doc(
    "messageFilterLazy",
    {
        condition: ""
    },
    "Lets messages pass through when condition is met.",
    undefined,
    {
        inlets: 2
    });

// todo: Actually implement
export const messageFilterLazy = (object, condition) => {
    let stored = undefined;
    return (msg) => {
        if (condition()) {
            return msg;
        }
    };
};



doc(
    "dedupe",
    {
    },
    "only pass if different");

export const dedupe = (o) => {
    let stored;
    return ([msg]) => {
        if (msg !== stored) {
            stored = msg;
            return [msg];
        }
    };
};
